<template>
    <div class="lo router">
        <loPage>
            <loSection>
                <loArticle>
                    <gCartList>
                        <gCartListHeader>
                            <mdCartCaption
                                :caption="caption"
                                :minorCaption="$t('site.noun.orderno') +' '+ inqtno"
                            >
                                <div class="func">
                                    <cpBtn
                                        themes="success"
                                        icon="arrow_back"
                                        extendClass="is-hover"
                                        @click.prevent="goBack"
                                    >{{ $t('site.func.previouspage') }}</cpBtn>
                                </div>
                            </mdCartCaption>
                            <mdStepEssay
                                :node="stepList"
                            ></mdStepEssay>
                        </gCartListHeader>
                        <gCartListContent v-if="orderList.length">
                            <gCartInfoSection>
                                <div class="md item-list">
                                    <ul>
                                        <li v-for="(item, index) in orderList" :key="index">
                                            <mdCartInfo
                                                :sn="item.sn"
                                                :node="item"
                                                :setPrice="type == 0? caption: item.up"
                                                :editable="type == 1? 'inquiry': 'none'"
                                                :ref="'mdCartInfo-'+ index"
                                            ></mdCartInfo>
                                        </li>
                                    </ul>
                                </div>
                                <mdEditorForPrice
                                    :caption="$t('page.shoppingcart.func.ordertotal')"
                                    :sub="isTax ? $t('page.shoppingcart.func.tax') : ''"
                                    :price="$okaTool.numberToStringFormat(orderInfo.aftertax)"
                                ></mdEditorForPrice>
                                <mdInfoCard
                                    :caption="$t('page.shoppingcart.caption.ordersummary')"
                                    :class="[toggleState? 'slide-in': 'slide-out']"
                                >
                                    <div
                                        v-if="type == 1"
                                        slot="top"
                                        class="func"
                                    >
                                        <a class="is-font is-save" v-if="editData" @click.prevent="saveClient">{{ $t('cartList.saveClient') }}</a>
                                        <a class="is-font is-edit" v-else @click.prevent="editClient">{{ $t('cartList.editClient') }}</a>
                                    </div>
                                    <div
                                        v-else
                                        slot="top"
                                        class="func"
                                        :class="[toggleState? 'is-active': '']"
                                    >
                                        <a class="is-open" @click.prevent="toggle"></a>
                                    </div>
                                    <ul slot="list">
                                        <li v-if="orderList.length">
                                            <div class="key">{{ $t('page.shoppingcart.func.ordertotalqty') }}</div>
                                            <div class="value">{{ orderList.length }}</div>
                                        </li>
                                        <li v-if="orderInfo.original">
                                            <div class="key">{{ $t('page.shoppingcart.func.original') }}</div>
                                            <div class="value">{{ $okaTool.numberToStringFormat(orderInfo.original) }}</div>
                                        </li>
                                        <li v-if="allowancePrice">
                                            <div class="key">{{ $t('page.shoppingcart.func.discount') }}</div>
                                            <div class="value">{{ this.$okaTool.numberToStringFormat(allowancePrice) }}</div>
                                        </li>
                                        <li v-if="isTax && orderInfo.tax">
                                            <div class="key">{{ $t('page.shoppingcart.func.taxCaption') }}</div>
                                            <div class="value">{{ this.$okaTool.numberToStringFormat(orderInfo.tax) }}</div>
                                        </li>
                                        <li v-if="creditBalance !== null">
                                            <div class="key">{{ $t('site.noun.creditbalance') }}</div>
                                            <div
                                                class="value"
                                                :class="[creditBalance > 0? '': 'is-danger']"
                                            >{{ this.$okaTool.numberToStringFormat(creditBalance) }}</div>
                                        </li>
                                        <li v-if="editData || (!editData && client.cuodno)">
                                            <div class="key">{{ $t('popup.dropshipping.caption.customerorder') }}</div>
                                            <div
                                                v-if="editData"
                                                class="value"
                                            >
                                                <div class="cp input text">
                                                    <input type="text" v-model="client.cuodno" name="cuodno" />
                                                </div>
                                            </div>
                                            <div
                                                v-else
                                                class="value"
                                            >{{ client.cuodno }}</div>
                                        </li>
                                        <template v-if="division == 'TRL'">
                                            <li class="is-block">
                                                <div class="key">{{ $t('popup.dropshipping.caption.customeradd') }}</div>
                                                <div
                                                    v-if="editData"
                                                    class="value"
                                                >
                                                    <div class="cp input select">
                                                        <select v-model="clientData" name="clientData" @change="changeClient">
                                                            <option value="">{{ $t('site.select.default') }}</option>
                                                            <option v-for="item in adcunoAddress" :key="item.adcuno +'@'+ item.cufn +'@'+ item.dlsite" :value="item.adcuno +'@'+ item.cufn +'@'+ item.dlsite">{{ item.dlsite }}</option>
                                                        </select>
                                                    </div>
                                                </div>
                                                <div
                                                    v-else
                                                    class="value"
                                                >{{ client.dlsite || user.dlsite }}</div>
                                            </li>
                                        </template>
                                        <template v-else>
                                            <li v-if="editData || (!editData && client.adcuno && client.cufn)">
                                                <div class="key">{{ $t('popup.dropshipping.caption.recipient') }}</div>
                                                <div
                                                    v-if="editData"
                                                    class="value"
                                                >
                                                    <div class="cp input select">
                                                        <select v-model="clientData" name="clientData" @change="changeClient">
                                                            <option value="">{{ $t('site.select.default') }}</option>
                                                            <option v-for="item in adcunoAddress" :key="item.adcuno +'@'+ item.cufn +'@'+ item.dlsite" :value="item.adcuno +'@'+ item.cufn +'@'+ item.dlsite">{{ item.adcuno +' / '+ item.cufn }}</option>
                                                            <option value="/">新增</option>
                                                        </select>
                                                    </div>
                                                </div>
                                                <div
                                                    v-else
                                                    class="value"
                                                >{{ client.adcuno +' / '+ client.cufn }}</div>
                                            </li>
                                            <li class="is-block">
                                                <div class="key">{{ $t('popup.dropshipping.caption.customeradd') }}</div>
                                                <div class="value">{{ client.dlsite || user.dlsite }}</div>
                                            </li>
                                        </template>
                                        <template v-if="division == 'PVC'">
                                            <li>
                                                <div class="key">{{ $t('page.shoppingcart.caption.pickup') }}</div>
                                                <div
                                                    v-if="editData"
                                                    class="value"
                                                >   
                                                    <input class="slidecheck" type="checkbox" v-model="client.iscustomerpickup" name="iscustomerpickup" id="iscustomerpickup" /><label for="iscustomerpickup"></label>
                                                </div>
                                                <div
                                                    v-else
                                                    class="value"
                                                >{{client.iscustomerpickup ? $t('page.shoppingcart.caption.yes') : $t('page.shoppingcart.caption.no')}}</div>
                                            </li>
                                            <li>
                                                <div class="key">{{ $t('page.shoppingcart.caption.deliverycontact') }}</div>
                                                <div
                                                    v-if="editData"
                                                    class="value"
                                                >   
                                                    <input class="slidecheck" type="checkbox" v-model="client.isactualdelivery" name="isactualdelivery" id="isactualdelivery" /><label for="isactualdelivery"></label>
                                                </div>
                                                <div
                                                    v-else
                                                    class="value"
                                                >{{client.isactualdelivery ? $t('page.shoppingcart.caption.yes') : $t('page.shoppingcart.caption.no')}}</div>
                                            </li>
                                        </template>
                                        <li :class="[editData? 'is-input': 'is-block']">
                                            <div class="key">
                                                {{ $t('page.shoppingcart.caption.remarks') }}
                                                &nbsp;
                                                <cpLabel
                                                    :themes="remarkwordsLength > remarkwordsMax? 'danger': 'info'"
                                                    :text="this.$t('remarks.wordsMax', { max: remarkwordsMax, length: remarkwordsLength })"
                                                ></cpLabel>
                                            </div>
                                            <div
                                                v-if="editData"
                                                class="value"
                                            >
                                                <div class="cp input textarea"  :class="[errors.has('remark')? 'is-error': '']" :data-error="errors.first('remark')">
                                                    <textarea v-model="client.remark"  v-validate="'max:'+ remarkwordsMax" name="remark" id="remark"></textarea>
                                                </div>
                                            </div>
                                            <div
                                                v-else
                                                class="value"
                                            >{{ client.remark }}</div>
                                        </li>
                                    </ul>
                                </mdInfoCard>
                                <mdInfoCard
                                    v-if="type == 3 || type == 4"
                                    :caption="$t('page.quotation.caption.shippingstatus')"
                                >
                                    <div class="cp scale" slot="bottom">
                                        <ul>
                                            <li
                                                v-for="(item, key) in shipmentTable"
                                                :key="key"
                                            >
                                                <a class="div">
                                                    <div class="name">{{ key }}</div>
                                                    <div class="num">{{ getWidth(item) }}</div>
                                                    <div class="btn">
                                                        <cpBtn
                                                            icon="visibility"
                                                            themes="info"
                                                            :title="$t('page.myorders.title.show')"

                                                            @click.prevent="popCargoData(key)"
                                                        ></cpBtn>
                                                    </div>
                                                    <div class="scale"
                                                        @mouseenter="show($event, item)"
                                                    >
                                                        <div class="scale-bar">
                                                            <div class="size"
                                                                :style="{
                                                                    width: getWidth(item)
                                                                }"
                                                            ></div>
                                                        </div>
                                                    </div>
                                                </a>
                                            </li>
                                        </ul>
                                    </div>
                                </mdInfoCard>
                                <mdBtnList
                                    :content="btns"

                                    @sendEvent="receiveEvent"
                                ></mdBtnList>
                            </gCartInfoSection>
                        </gCartListContent>
                        <div
                            v-else
                            class="md"
                        >
                            <cpStatus
                                tag="div"
                                themes="major"
                                icon="warning"
                                :text="$t('page.orderhistory.status.noresults')"
                            ></cpStatus>
                        </div>
                    </gCartList>
                </loArticle>
            </loSection>
        </loPage>
    </div>
</template>

<script>
    import loPage from '@/components/loPage'
    import loSection from '@/components/loSection'
    import loArticle from '@/components/loArticle'
    import gCartList from '@/components/gCartList'
    import gCartListHeader from '@/components/gCartListHeader'
    import mdCartCaption from '@/components/mdCartCaption'
    import mdStepEssay from '@/components/mdStepEssay'
    import gCartListContent from '@/components/gCartListContent'
    import gCartInfoSection from '@/components/gCartInfoSection'
    import mdCartInfo from '@/components/mdCartInfo'
    import gCartInfoAside from '@/components/gCartInfoAside'
    import mdEditorForPrice from '@/components/mdEditorForPrice'
    import mdBtnList from '@/components/mdBtnList'
    import mdInfoCard from '@/components/mdInfoCard'
    import cpStatus from '@/components/cpStatus'
    import cpLabel from '@/components/cpLabel'
    import cpBtn from '@/components/cpBtn'

    import { Decimal } from 'decimal.js';
    import { mapState, mapMutations, mapGetters } from 'vuex'

    let $defaultClient = {
            cuodno: '',
            adcuno: '',
            cufn: '',
            dlsite: '',
            remark: '',
        }

    export default {
        components: {
            loPage,
            loSection,
            loArticle,
            gCartList,
            gCartListHeader,
            mdCartCaption,
            mdStepEssay,
            gCartListContent,
            gCartInfoSection,
            mdCartInfo,
            gCartInfoAside,
            mdEditorForPrice,
            mdBtnList,
            mdInfoCard,
            cpStatus,
            cpLabel,
            cpBtn,
        },
        data: function(){

            return {
                orderData: [],
                shipmentData: [],
                cargoData: [],
                progress: [],
                client: $defaultClient,
                shoppingBoard: '', //S-60
                shippingItem: '', //S-65
                toggleState: true,
                priceData: {
                    caption: this.$t('page.shoppingcart.func.ordertotal'),
                    sub: this.isTax ? this.$t('page.shoppingcart.func.tax') : '',
                    price: '',
                },
                orderList: [],
                editData: false,
                adcunoAddress: [],
                remarkwordsMax: 30,
                clientData: '',
                allowancePrice: 0,
                contactRemark: [],
            }
        },
        computed: {
            ...mapState([
                'productList',
                'user',
                'creditBalance',
            ]),
            ...mapGetters([
                'division'
            ]),
            codiv: function(){
                let $user = this.user;

                return $user.co +''+ $user.div;
            },
            remarkwordsLength: function(){ //備註的字數
                let $client = this.client,
                    _remark = $client.remark || '';

                return _remark.length;
            },
            isTax: function(){ //是否有5%營業稅
                let $user = this.user

                //https://www.notion.so/84092b92b33d47bd99f34da8b905b7a1
                if( $user.cukd === 'E' || $user.cukd === 'B' ){
                    return false;
                }else {
                    return true;
                }
            },
            query: function(){
                return this.$route.query || {}
            },
            inqtno: function(){
                let $orderData = this.orderData,
                    $orderData_0 = $orderData[0] || {}

                return $orderData_0.inqtno || this.query.inqtno;
            },
            odno: function(){
                let $orderData = this.orderData,
                    $orderData_0 = $orderData[0] || {}

                return $orderData_0.odno;
            },
            type: function(){ //0詢價 1報價 2訂單 3出貨 4取消
                let $progress = this.progress,
                    _result = 0;

                $progress.forEach(item => {
                    
                    if( item.finishtime ) {
                        _result = item.type;
                    }
                    
                    if(item.status <= 0){ //增加逾期與取消判定
                        _result = 4;
                        return;
                    }
                });

                return _result;
            },
            hasClient: function(){
                let $client = this.client,
                    _hasClient = false;

                for(var item in $client){
                    if($client[item] && item !== 'dlsite'){
                        _hasClient = true
                        break;
                    }
                }
             
                return _hasClient;
            },
            caption: function(){
                let _type = this.type,
                    _caption = 'order.type.' + _type;

                return this.$t(_caption)
            },
            shipmentTable: function() {
                let $orderList = this.orderList,
                    $shipmentData = this.shipmentData,
                    $result = {}

                $orderList.forEach(item => {
                    let _dsr = item.product_s,
                        _qty = item.qty;

                    if( $result[_dsr] ){
                        $result[_dsr].allQty = $result[_dsr].allQty + _qty;
                    }else {
                        $result[_dsr] = {
                            allQty: _qty,
                            shipmentQty: 0,
                        }
                    }
                });

                $shipmentData.forEach(item => {
                    let _dsr = item.dsr,
                        $detail = item.detail;

                    $detail.forEach(detail => {
                        
                        if( $result[_dsr] ) {
                            $result[_dsr].shipmentQty = $result[_dsr].shipmentQty + detail.dlqty;
                        }
                    });
                });

                return $result;
            },
            orderInfo: function(){

                if( this.type == 0 ) {
                    
                    return {
                        original: this.$t('page.myorders.name.inquiry'),
                        beforetax: this.$t('page.myorders.name.inquiry'),
                        aftertax: this.$t('page.myorders.name.inquiry'),
                        tax: this.$t('page.myorders.name.inquiry'),
                    }
                }else {
                    let $aftertax = new Decimal(0),
                        $tax = new Decimal(0),
                        $allowancePrice = new Decimal(this.allowancePrice),
                        $list = this.orderList,
                        $original = $list.reduce((all, item) => {
                            let _qty = parseFloat(item.qty || 0, 10);

                            if( isNaN(_qty) ) {
                                _qty = 0;
                            }

                            let $qty = new Decimal(_qty),
                                $up = new Decimal(item.up);

                            let $price = $qty.mul($up);

                            return all.add($price);
                        }, new Decimal(0)),
                        $beforetax = $original.add($allowancePrice);
                
                    if( this.isTax ){
                        $aftertax = $beforetax.mul(new Decimal(1.05));
                        $tax = $beforetax.mul(new Decimal(0.05));
                    }else{
                        $aftertax = $beforetax;
                    }
                
                    return {
                        original: parseFloat($original.toFixed(2), 10), //原始
                        beforetax: parseFloat($beforetax.toFixed(2), 10), //稅前
                        aftertax: parseFloat($aftertax.toFixed(2), 10), //稅後
                        tax: parseFloat($tax.toFixed(2), 10), //稅
                    }
                }
            },
            stepList: function(){
                let $progress = this.progress || [],
                    $result = []

                $progress.forEach(item => {
                    let _type = item.type,
                        _status = item.status;

                    let _caption = this.$t('order.type.'+ _type);

                    if( _status === -1 || _status === 0 ) {
                        _caption = this.$t('order.status.'+ _status);
                    }

                    let _text = '';

                    if( item.finishtime ) {
                        let $text = this.$okaTool.numberToDataFormat(item.finishtime);

                        _text = $text.ymdhm
                    }

                    $result.push({
                        caption: _caption,
                        text: _text,
                        status: item.finishtime? 'active': '',
                    });
                });

                return $result
            },
            btns: function(){
                let _type = this.type,
                    $result = []

                let $remove = {
                        themes: 'cancel',
                        icon: 'delete_outline',
                        text:this.$t('page.myorders.func.cancelinquiry'),
                        extendClass: 'is-large is-hover',
                        func: 'remove',
                    },
                    $send = {
                        themes: 'send',
                        icon: 'done',
                        text:this.$t('page.myorders.func.ordernow'),
                        extendClass: 'is-large is-hover',
                        func: 'send',
                    },
                    $contact = {
                        themes: 'success',
                        icon: 'chat_bubble_outline',
                        text: this.$t('site.func.contactsales'),
                        extendClass: 'is-large ',
                        func: 'contact',
                    },
                    $addAgain = {
                        themes: 'again',
                        icon: 'add_shopping_cart',
                        text: this.$t('product.myorders.func.buyagain'),
                        extendClass: 'is-large is-hover',
                        func: 'addAgain',
                    },
                    // $receipt = {
                    //     themes: 'warning',
                    //     icon: 'receipt_long',
                    //     text: this.$t('page.myorders.func.downloadinvoice'),
                    //     extendClass: 'is-large is-hover',
                    //     func: 'receiptDownload',
                    // },
                    $download = {
                        themes: 'warning',
                        icon: 'article',
                        text: this.$t('page.myorders.func.downloadquotation'),
                        extendClass: 'is-large is-hover',
                        func: 'quotationDownload',
                    }

                let _hasShipment = false; //判斷加入 receipt 但沒有 odno

                this.shipmentData.forEach(item => {

                    if( item.detail && item.detail.length ) {
                        _hasShipment = true;
                    }
                });

                if( _type == 0 ) {
                    $result.push($contact);
                    $result.push($remove);
                }else if( _type == 1 ) {
                    $result.push($contact);
                    $result.push($download);
                    $result.push($send);
                    $result.push($remove);
                }else if( _type == 2 ) {
                    $result.push($contact);
                    $result.push($download);
                    $result.push($remove);
                }else if( _type == 3 ) {
                    $result.push($contact);

                    // if( _hasShipment && this.odno ) {
                    //     $result.push($receipt);
                    // }

                    $result.push($addAgain);
                }else if( _type == 4 ) {
                    $result.push($contact);

                    // if( _hasShipment && this.odno ) {
                    //     $result.push($receipt);
                    // }

                    $result.push($addAgain);
                }

                return $result;
            },
        },
        watch: {
            '$route.query': {
                handler: function(){
                    this.reload();
                },
                deep: true,
            },
            // type: {
            //     handler: function(){
            //         this.reload();
            //     }
            // },
        },
        methods: {
            ...mapMutations([
                'reload',
                'catchError',
                'pushPopUp',
                'pushNotification',
                'pushToolTip',
                'buyAgain',
                'initCredit',
            ]),
            quotationDownload: function(){
             
                let _url = this.$siteTool.apiUrl({
                        class: 'Quotation',
                        func: 'Download',
                    }),
                    $condition = {
                        inqtno: this.inqtno,
                    }

                this.$http.post(_url, $condition,{ responseType: 'blob' }).then(res=>{
                    this.$siteTool.download(res)

                    this.pushNotification({
                        type: 'notification',
                        content: {
                            html: this.$t('site.status.downloadSuccess'),
                            status: 'success'
                        }
                    });
                }).catch(error => {

                    this.catchError({
                        error: error,
                        callback: this.quotationDownload,
                    });
                })
            },
            // receiptDownload: function(opt){ //沒有 odno
             
            //     let _url = this.$siteTool.apiUrl({
            //             class: 'Invoice',
            //             func: 'Download',
            //         }),
            //         $condition = {
            //             odno: this.odno,
            //         }

            //     this.$http.post(_url, $condition,{ responseType: 'blob' }).then(res=>{
            //         this.$siteTool.download(res)

            //         this.pushNotification({
            //             type: 'notification',
            //             content: {
            //                 html: this.$t('site.status.downloadSuccess'),
            //                 status: 'success'
            //             }
            //         });
            //     }).catch(error => {

            //         this.catchError({
            //             error: error,
            //             callback: () => {
            //                 this.receiptDownload(opt)
            //             },
            //         });
            //     })
            // },
            changeClient: function(){

                if( this.clientData === '/' ) {
                    this.$set(this, 'clientData', '');

                    this.pushPopUp({
                        type: 'prompt',
                        content: {
                            caption: this.$t('page.shoppingcart.func.addCUNO'),
                            action: (val) => {
                                this.$siteTool.addCUNO(val, (data) => {

                                    if( !this.adcunoAddress.find(adcunoAddres => adcunoAddres.adcuno === data.adcuno) ) {
                                        this.adcunoAddress.push(data);
                                    }
                                    
                                    this.$set(this, 'clientData', data.adcuno +'@'+ data.cufn +'@'+ data.dlsite);
                                    this.changeClientCore(data.adcuno, data.cufn, data.dlsite);
                                });
                            }
                        }
                    });
                }else {
                    let _clientData = this.clientData || '@@',
                        $clientData = _clientData.split('@');

                    this.changeClientCore($clientData[0], $clientData[1], $clientData[2]);
                }
            },
            changeClientCore: function(adcuno, cufn, dlsite){
                this.$set(this.client, 'adcuno', adcuno);
                this.$set(this.client, 'cufn', cufn);
                this.$set(this.client, 'dlsite', dlsite);
            },
            toggle: function(){
                this.$set(this, 'toggleState', !this.toggleState);
            },
            addAgain: function(){
                this.buyAgain(this.inqtno);
            },
            show: function(evt, opt){
                
                this.pushToolTip({
                    type: 'toolTip',
                    event: evt,
                    content: {
                        caption: this.$t('page.myorders.caption.shippingtotal'),
                        html: opt.shipmentQty + ' KG' + ' / ' + opt.allQty +  ' KG'
                    },
                    pointerEvents: 'none'
                })
            },
            removeCore: async function(){
                let _url = this.$siteTool.apiUrl({
                        class: 'Order',
                        func: 'CancelOrder',
                    }),
                    $condition = {
                        inqtno: this.inqtno
                    }

                try {
                    await this.$http.post(_url, $condition);

                    this.pushNotification({
                        type: 'notification',
                        content: {
                            html: this.$t('site.status.removesuccess'),
                            status: 'success'
                        }
                    });

                    this.$router.push('/system/account?page=purchase&tab='+ this.type);
                    
                }catch(error) {

                    this.catchError({
                        error: error,
                        callback: this.removeCore,
                    });
                }
            },
            remove: function(){

                this.pushPopUp({
                    type: 'confirm',
                    content: {
                        html: this.$t('page.myorders.status.cancelinquiry'),
                        action: this.removeCore
                    }
                });
            },
            contact: function(){ //聯絡營業員
                let _inqtno = this.inqtno,
                    _url = this.$siteTool.apiUrl({
                        class: 'ContactSalesInOrder',
                        func: 'Info',
                    }),
                    $condition = {
                        inqtno: _inqtno, 
                    }

                this.$http.post(_url, $condition).then(res => { //弄完所有設定後開始取資料

                    if( res ){
                        
                        let _content = this.caption +': '+ _inqtno,
                            $orderList = this.orderList || []

                        let $_orderScript = (order) => {
                                let _product_s = order.product_s,
                                    _qty = order.qty,
                                    _date = order.customer_need_date;

                                let $str = [_product_s]

                                if( _qty ) {
                                    $str.push(this.$okaTool.numberToStringFormat(_qty) +' '+ order.un);
                                }

                                if( _date ) {
                                    $str.push(_date.replaceAll('/', '-'));
                                }

                                return $str.join(' / ');
                            }

                        if( $orderList.length === 1 ) {
                            _content += '<br>'+ this.$t('site.noun.product') +': '+ $_orderScript($orderList[0]);
                        }else if( $orderList.length > 1 ) {
                            $orderList.forEach((order, index) => {
                                _content += '<br>'+ this.$t('site.noun.product') +' '+ (index + 1) +': '+ $_orderScript(order);
                            })
                        }

                        res.nextSend = _content;

                        this.pushPopUp({
                            type: 'showSalse',
                            content: res
                        });
                    }
                }).catch(error => {

                    this.catchError({
                        error: error,
                        callback: () => {
                            this.contact();
                        }
                    });
                });
            },
            send: async function(){
                let $list = this.orderList,
                    $response = await Promise.all($list.map((item, index) => this.$refs['mdCartInfo-'+ index][0].validate())),
                    _result = $response.every(item => item);

                let $_core = async () => {
                        let _url = this.$siteTool.apiUrl({
                                class: 'Order',
                                func: 'EditDetail',
                            }),
                            $condition = {
                                inqtno: this.inqtno,
                                remark: this.client.remark,
                                order: [],
                            }

                        let _all = 0

                        this.orderList.forEach(order => {
                                let _qty = parseFloat(order.qty, 10),
                                    _time = order.customer_need_date;

                                _time = _time.replaceAll('/', '-');
                                _time = new Date(_time).getTime();
                                _time = _time / 1000;

                            _all += _qty;

                            $condition.order.push({
                                sn: order.sn,
                                it: order.it,
                                prlqty: _qty,
                                cndat: _time,
                            })
                        });

                        if( this.editData ) {

                            this.pushPopUp({
                                type: 'alert',
                                content: {
                                    html: this.$t('popup.edit.func.alert'),
                                }
                            });

                        }else if( _all ) {

                            try {
                                let $inqtnoList = await this.$http.post(_url, $condition);

                                if( $inqtnoList && $inqtnoList.length ) { //打無人工審核

                                    let _url = this.$siteTool.apiUrl({
                                        class: 'Order',
                                        func: 'CheckAgreement'
                                    })

                                    for(let i = 0; i < $inqtnoList.length; i++){
                                        let $condition = {
                                                inqtno: $inqtnoList[i],
                                            }

                                        await this.$http.post(_url, $condition);
                                    }
                                }

                                this.initCredit(); //重取授信

                                this.pushNotification({
                                    type: 'notification',
                                    content: {
                                        html: this.$t('site.status.ordersuccess'),
                                        status: 'success'
                                    }
                                });

                                this.$router.push('/system/account?page=purchase&tab='+ this.type);
                                
                            }catch(error) {

                                this.catchError({
                                    error: error,
                                    callback: this.send,
                                });
                            }
                        }else {
                            this.remove();
                        }
                    }

                if ( _result ){

                    this.initCredit(() => {
                        let _creditBalance = this.creditBalance,
                            _aftertax = this.orderInfo.aftertax;

                        if( _creditBalance !== null && _aftertax > _creditBalance ) {

                            this.pushPopUp({
                                type: 'confirm',
                                content: {
                                    html: this.$t('alert.exceededBalance'),
                                    actionName: this.$t('page.shoppingcart.func.placeorder'),
                                    action: $_core
                                }
                            });
                        }else {
                            $_core();
                        }
                    });

                }else {
                    //阿就沒通過阿
                }
            },
            changeShoppingInfo: function(key){
                this.$set(this, 'shoppingBoard', key);
            },
            popCargoData: function(opt){
                let $cargoData = this.cargoData,
                    $result = {      
                        title: [],
                        content: []
                    };
                
                $result.title.push(
                    {
                       caption: this.$t('popup.shippinghistory.caption.trackingnum'),
                       prop: 'orderno',
                       visible: true,
                       sortable: true,
                       showtype: 'text',
                    },
                    {
                       caption: this.$t('popup.shippinghistory.caption.product'),
                       prop: 'product',
                       visible: true,
                       showtype: 'text',
                    },
                    {
                       caption: this.$t('popup.shippinghistory.caption.qty'),
                       prop: 'quantity',
                       visible: true,
                       sortable: true,
                       showtype: 'text',
                    },
                    {
                       caption: this.$t('popup.shippinghistory.caption.unit'),
                       prop: 'unit',
                       visible: true,
                       showtype: 'text',
                    },
                    {
                       caption: this.$t('popup.shippinghistory.caption.logistic'),
                       prop: 'carcorp',
                       visible: true,
                       showtype: 'text',
                    },
                    {
                       caption: this.$t('popup.shippinghistory.caption.plates'),
                       prop: 'carno',
                       visible: true,
                       sortable: true,
                       showtype: 'text',
                    },
                    {
                       caption: this.$t('popup.shippinghistory.caption.dispatch'),
                       prop: 'departtime',
                       visible: true,
                       sortable: true,
                       showtype: 'text',
                    },
                    {
                       caption: this.$t('popup.shippinghistory.caption.origin'),
                       prop: 'plant',
                       visible: true,
                       sortable: true,
                       showtype: 'text',
                    },
                );

                $cargoData.forEach((item, index) =>{
                    if(item.dsr === opt){
                        let $date = this.$okaTool.numberToDataFormat(item.opltdattm),
                        _date = $date.ymdhm;                    //year-month-date hour:minutes
                        _date = _date.replace(/\-/g, '/');          //year/month/date hour:minutes

                        $result.content.push({
                            orderno: item.vhno,        //交運單號
                            product: item.dsr,         //產品
                            quantity: item.dlqty,      //交運量
                            unit: item.un,             //單位
                            carcorp: item.carrfnm,      //車行名稱
                            carno: item.carno,         //車牌號碼
                            departtime: _date,                  //出貨時間
                            plant: item.outpz,         //出貨廠
                            sn: index,
                            show: true
                        })
                    }
                });

                this.pushPopUp({
                    type: 'table',
                    content:{
                        caption: opt + this.$t('popup.shippinghistory.title.shipmentinfo'),
                        table: $result,
                        width: 1200,
                        havePageination:false,
                    }
                });
                
            },
            getWidth: function(opt){
                return parseInt(opt.shipmentQty / opt.allQty * 100) +'%'
            },
            getProductData: function(dsr){
                let $productList = this.productList,
                    $target = $productList.find(product => product.product_s === dsr.dsr && product.product_codiv === dsr.co + dsr.div);

                if( $target ) {
                    return $target;
                }else {
                    return null;
                }
            },
            saveClient: function(){
                let $_core = async () => {

                        let _url = this.$siteTool.apiUrl({
                                class: 'CartMaster',
                                func: 'Edit',
                            }),
                            $condition = {
                                ...this.client,
                                inqtno: this.inqtno,
                            }

                        try {
                            await this.$http.post(_url, $condition);

                            this.$set(this, 'editData', false);
                            
                        }catch(error) {

                            this.pushNotification({
                                type: 'notification',
                                content: {
                                    html: this.$siteConfig.publishError,
                                    status: 'danger'
                                }
                            });

                            this.$set(this, 'clientData', '');
                            this.$set(this, 'client', $defaultClient);
                        }
                    }

                this.$validator.validate().then(result => {

                    if (!result){
                        //啊就沒通過啊
                    }else {
                        $_core();
                    }
                });
            },
            editClient: function(){
                this.$set(this, 'editData', true);
            },
            initCargoData: function(data){
                this.$set(this, 'cargoData', data);

                if(data[0] && data[0].dsr){
                    this.$set(this, 'shippingItem', data[0].dsr)
                }
            },
            getCargoData: function(){
                let _url = this.$siteTool.apiUrl({
                    class:'Order',
                    func: 'ShipmentProgressDetail',
                }),
                    $condition = {
                        inqtno: this.inqtno
                    }

                return this.$http.post(_url, $condition);
            },
            goBack: function(){
                this.$router.go(-1);
            },
            initShipmentData: function(data){
                this.$set(this, 'shipmentData', data);

                if( data[0] && data[0].dsr ) {
                    this.$set(this, 'shoppingBoard', data[0].dsr);
                }
            },
            getShipmentData: function(){
                let _url = this.$siteTool.apiUrl({
                        class: 'Order',
                        func: 'ShipmentProgress',
                    }),
                    $condition = {
                        inqtno: this.inqtno
                    }

                return this.$http.post(_url, $condition);
            },
            getOrderData: function(){
                let _url = this.$siteTool.apiUrl({
                        class: 'Order',
                        func: 'Detail',
                    }),
                    $condition = {
                        inqtno: this.inqtno,
                        pre_type: this.query.type,
                    }

                return this.$http.post(_url, $condition);
            },
            getContactRemark: function(dsr){
                //取得聯絡備註
                let _url = this.$siteTool.apiUrl({
                        class: 'ContactRemark',
                    }),
                    $condition = {
                        product_s: dsr
                    }

                return this.$http.post(_url, $condition);
            },
            initOrderData:  function(data){
                let $result = [],
                    $contactRemark = [],
                    _contact = null;

                data.forEach(async item => {
                    let $target = this.getProductData(item) || {},
                        $customer_need_date = item.cndat;
                        
                    //取得聯絡備註
                    _contact = $contactRemark.find(obj => obj.product_s === item.dsr);
                    if(!_contact){
                        let $data = await this.getContactRemark(item.dsr)

                        _contact = $data.contact_remark;
                        
                        $contactRemark.push({
                            product_s: item.dsr,
                            contact_remark: _contact,
                        });
                    }

                    //判斷空值 如果不是空值做轉換
                    if( $customer_need_date){
                        $customer_need_date = this.$okaTool.numberToDataFormat($customer_need_date);
                        $customer_need_date = $customer_need_date.ymd;
                        $customer_need_date = $customer_need_date.replace(/\-/g, '/');
                    }    
                    
                    $result.push({
                        sn: item.sn,
                        customer_need_date: $customer_need_date,
                        imageurl: item.imageurl || '',
                        label: $target.label || '',
                        package_s: item.pkty,
                        product_b: $target.product_b || '',
                        product_m: $target.product_m || '',
                        product_s: $target.product_s || item.dsr,
                        alias: $target.alias,
                        qty: item.prlqty,
                        quality: item.used,
                        xend: item.xend? true: false,
                        up: item.up,
                        un: item.un,
                        it: item.it,
                        contactRemark: _contact,
                        outmfct: item.outmfct,
                    });
                });

                this.$set(this, 'orderData', data);
                this.$set(this, 'orderList', $result);
            },
            getClient: function(){
                let _url = this.$siteTool.apiUrl({
                        class: 'CartMaster',
                        func: 'Info',
                    }),
                    $condition = {
                        inqtno: this.inqtno
                    }

                return this.$http.post(_url, $condition);
            },
            initClient: function(data){

                if( data ){

                    for( let _key in $defaultClient ) {

                        if( !data[_key] ) {
                            data[_key] = $defaultClient[_key]
                        }
                    }

                    if( data.adcuno && data.cufn && data.dlsite ) {
                        this.$set(this, 'clientData', data.adcuno +'@'+ data.cufn +'@'+ data.dlsite);
                    }

                    this.$set(this, 'client', data);
                }else {
                    this.$set(this, 'clientData', '');
                    this.$set(this, 'client', $defaultClient);
                }
            },
            getAdcunoAddress: function(){
                let _url = this.$siteTool.apiUrl({
                        class: 'AdcunoAddress',
                        func: 'List',
                    }),
                    $condiction = {
                        codiv: this.codiv
                    }

                return this.$http.post(_url, $condiction);
            },
            initAdcunoAddress:function(data){
                let $client = this.client,
                    _adcuno = $client.adcuno,
                    _cufn = $client.cufn,
                    _dlsite = $client.dlsite;

                if( _adcuno && _cufn && _dlsite ) {
                    let $target = data.find(item => item.adcuno === _adcuno && item.cufn === _cufn && item.dlsite === _dlsite);

                    if( !$target ) {

                        data.unshift({
                            adcuno: _adcuno,
                            codiv: '__',
                            cufn: _cufn,
                            dlsite: _dlsite,
                        })
                    }
                }
                
                this.$set(this, 'adcunoAddress', data);
            },
            getProgress: function(){
                let _url = this.$siteTool.apiUrl({
                        class: 'Order',
                        func: 'OrderProgress',
                    }),
                    $condition = {
                        inqtno: this.inqtno
                    }

                return this.$http.post(_url, $condition);
            },
            initProgress: function(data){
                this.$set(this, 'progress', data);
            },
            getDiscount: function(){
                let _url = this.$siteTool.apiUrl({
                        class: 'Order',
                        func: 'Discount',
                    });

                return this.$http.post(_url, {
                    inqtno: this.inqtno,
                });
            },
            initDiscount: function(data){

                if( this.type === 2 || this.type === 3 ) { //訂單 or 出貨
                    let $data = data || {},
                        _discount = $data.discount || 0;

                    _discount = _discount * -1;

                    this.$set(this, 'allowancePrice', _discount);
                }
            },
            init: async function(){

                try {
                    let $response = await Promise.all([
                            this.getOrderData(),
                            this.getShipmentData(),
                            this.getClient(),
                            this.getProgress(),
                            this.getCargoData(),
                            this.getAdcunoAddress(),
                            this.getDiscount(),
                        ]);

                    let [order, shipment, client, progress, cargo, adcunoAddress, discount] = $response;

                    this.initOrderData(order);
                    this.initShipmentData(shipment);
                    this.initClient(client);
                    this.initProgress(progress);
                    this.initCargoData(cargo);
                    this.initAdcunoAddress(adcunoAddress);
                    this.initDiscount(discount);
                    
                }catch(error) {

                    this.catchError({
                        error: error,
                        callback: this.init,
                    });
                }
            },
        },
        created: function(){
            this.initCredit();
            this.init();
        },
    }
</script>

<style scoped lang="scss">
    
    .md.item-list {

        li {
            background-color: $white;
            padding: $interval-m;
            border-radius: $border-radius;
            border: $border;

            + li {
                margin-top: $interval-m;
            }
        }
    }

    .cp.input.textarea {
        margin: $interval-m $interval-m 0;
        display: block;

        textarea {
            width: 100%;
            height: 120px;
        }
    }

    .lo.router {
        max-width: 1200px;
        margin: 0 auto;

        &::v-deep {

            .lo.page {
                flex-direction: column;
            }
        }
    }

    .cp.scale {

        ul {
            @extend %reset;
            padding: $interval-m;
        }

        li {

            + li {
                margin-top: $interval-m;
            }
        }

        .div {
            display: flex;
            cursor: pointer;
            transition: $transition;
        }

        .name {
            order: 0;
            padding: 0 $interval-m;
            display: flex;
            align-items: center;
            min-width: 90px;
        }

        .num {
            order: 2;
            padding: 0 $interval-m;
            display: flex;
            align-items: center;
        }

        .btn {
            order: 3;
        }

        .scale {
            order: 1;
            flex: 1;
            background-color: $light;
            border-radius: $border-radius;
            padding: $interval-xs;
            
            .scale-bar {
                position: relative;
                height: 32px;
            }

            .size {
                position: absolute;
                top: 0;
                left: 0;
                bottom: 0;
                background-color: $minor-color; 
                border-radius: $border-radius;       
            }  
        }
    }
    
    .disable {
        background-color: $light-gray;
    }
    .slidecheck {
        display: none;

        + label  {
            display: block;
            position: relative;
            font-size: 16px;
            line-height: 20px; /* 將 label 的高設為 20px */
            padding-left: 50px; /* 避開勾選框 */

            &::before { /* 勾選框的底 */
                content: '';
                position: absolute;
                top: 0;
                left: 0;
                width: 40px;
                height: 20px;
                background-color: $gray;
                border-radius: $border-radius;
            }

            &::after {
                content: '';
                position: absolute;
                top: 0;
                left: 0;
                width: 18px; /* 製作一個 20px * 20px 的開關 */
                height: 18px;
                border-width: 1px;
                border-style: solid;
                border-color: $gray;
                background-color: #fff;
                border-radius: $border-radius;
                transition: left 0.2s;
            }
        }

        &:checked {

            + label {

                &::before {
                    background-color: $major-color;
                    border-radius: $border-radius;
                }
                &::after {
                    border-color:  $major-color;
                    left: 20px; /* 開關往左移動 20px */
                    border-radius: $border-radius;
                }
            }
        }
    }
</style>
